<header-web (dataEvent)='setLanguage($event)' [Comercio]='true'></header-web>
<section class="container-fluid my-md-5 my-1 px-0">
  <div class="row mx-0">
    <div class="col-md-8 offset-md-2 col-12">
      <div class="container text-center">
        <h2 class="title text-lago d-none d-md-block">GALILEO-ERP EN TU NEGOCIO</h2>
        <h2 class="title fw-bold text-lago d-md-none d-block fs-2">GALILEO-ERP EN TU NEGOCIO</h2>
        <div class="px-md-5 px-1">
          <p class="lh-sm text fw-bold text-md-center text-justify">Simple e intuitivo, Galileo-ERP es un sistema que te
            ayuda a gestionar tu
            empresa y generar ventas con facturación electrónica, control de inventario y mucho más.</p>
          <p class="text lh-sm text-justify">La empresa Yachay, propone el software más completo de gestión empresarial
            y facturación electrónica integrado en la nube con el mismo poder que las aplicaciones tradicionales, pero a
            solo una fracción de costo y complejidad.</p>
          <a class="btn btn-danger btn-lg subtitle my-2" [routerLink]="['/contacto']"  role="button"> Solicitar mas información </a>
        </div>
      </div>
    </div>
  </div>
  <div class="w-100 px-5 pb-5 mt-3">
    <h4 class="subtitle text-center text-lago fw-bold mb-3">Galileo-ERP es un sistema que se adapta a tu negocio, puedes
      usarlo en:</h4>
    <div class="row px-md-5 px-0">
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 text-center">
        <img src="../../assets/image/servicios/erp-1.png" class="img-fluid" alt="">
        <h3 class="fw-bold title text-lago">Tiendas</h3>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 text-center">
        <img src="../../assets/image/servicios/erp-2.png" class="img-fluid" alt="">
        <h3 class="fw-bold title text-lago">Colegios</h3>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 text-center">
        <img src="../../assets/image/servicios/erp-3.png" class="img-fluid" alt="">
        <h3 class="fw-bold title text-lago">Minimarket</h3>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 text-center">
        <img src="../../assets/image/servicios/erp-4.png" class="img-fluid" alt="">
        <h3 class="fw-bold title text-lago">Grifos</h3>
      </div>
      <div class="w-100 my-3"></div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 text-center">
        <img src="../../assets/image/servicios/erp-8.png" class="img-fluid" alt="">
        <h3 class="fw-bold title text-lago">Hoteles</h3>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 text-center">
        <img src="../../assets/image/servicios/erp-6.png" class="img-fluid" alt="">
        <h3 class="fw-bold title text-lago">Bares</h3>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 text-center">
        <img src="../../assets/image/servicios/erp-7.png" class="img-fluid" alt="">
        <h3 class="fw-bold title text-lago">Ferreterías</h3>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 text-center">
        <img src="../../assets/image/servicios/erp-9.png" class="img-fluid" alt="">
        <h3 class="fw-bold title text-lago">Clínicas</h3>
      </div>
    </div>
  </div>
</section>
<section class="container mb-5 pb-5">
  <h1 class="text-center fw-bold title text-lago">GAlileo ERP en tu Negocio</h1>
  <div class="w-100">
    <div class="row mx-0 mt-5">
      <div class="col-lg-6 col-12">
        <div class="card border-0 mb-3">
          <div class="row no-gutters d-flex align-items-center">
            <div class="col-md-3 col-4">
              <img src="../../assets/image/recursos/ico-1.png" class="card-img" alt="...">
            </div>
            <div class="col-md-9 col-8">
              <div class="card-body text-md-start text-center">
                <h5 class="card-title fw-bold subtitle text-lago d-md-block d-none"><u>Reportes Inteligentes</u></h5>
                <p class="card-title fw-bold subtitle text-lago d-md-none d-block"><u>Reportes Inteligentes</u></p>
                <p class="card-text fw-bold text-md-left text color-1 text lh-sm text-justify">Información relevante en
                  tiempo real para analizar tu
                  negocio. Personaliza tus reportes según tus necesidades</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-12">
        <div class="card border-0 mb-3">
          <div class="row no-gutters d-flex align-items-center">
            <div class="col-md-3 col-4">
              <img src="../../assets/image/recursos/ico-2.png" class="card-img" alt="...">
            </div>
            <div class="col-md-9 col-8">
              <div class="card-body text-md-start text-center">
                <h5 class="card-title fw-bold subtitle text-lago d-md-block d-none"><u>Inventarios</u></h5>
                <p class="card-title fw-bold subtitle text-lago d-md-none d-block"><u>Inventarios</u></p>
                <p class="card-text fw-bold text-md-left text color-1 text lh-sm text-justify">Consulta el estado de tu
                  inventario en tiempo real y desde cualquier momento</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-12">
        <div class="card border-0 mb-3">
          <div class="row no-gutters d-flex align-items-center">
            <div class="col-md-3 col-4">
              <img src="../../assets/image/recursos/ico-3.png" class="card-img" alt="...">
            </div>
            <div class="col-md-9 col-8">
              <div class="card-body text-md-start text-center">
                <h5 class="card-title fw-bold subtitle text-lago d-md-block d-none"><u>Clientes y Proveedores</u></h5>
                <p class="card-title fw-bold subtitle text-lago d-md-none d-block"><u>Clientes y Proveedores</u></p>
                <p class="card-text fw-bold text-md-left text color-1 text lh-sm text-justify">Lleva el registro de
                  todos tus clientes, el histórico de
                  ventas, deudas, los saldos y todos sus movimientos.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-12">
        <div class="card border-0 mb-3">
          <div class="row no-gutters d-flex align-items-center">
            <div class="col-md-3 col-4">
              <img src="../../assets/image/recursos/ico-4.png" class="card-img" alt="...">
            </div>
            <div class="col-md-9 col-8">
              <div class="card-body text-md-start text-center">
                <!-- <h5 class="card-title fw-bold subtitle text-lago"><u>Facturación Electrónica</u></h5> -->
                <h5 class="card-title fw-bold subtitle text-lago d-md-block d-none"><u>Facturación Electrónica</u></h5>
                <p class="card-title fw-bold subtitle text-lago d-md-none d-block"><u>Facturación Electrónica</u></p>
                <p class="card-text fw-bold text-md-left text color-1 text lh-sm text-justify">Declara tus comprobantes
                  inmediatamente y no tengas
                  problemas con SUNAT</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-12">
        <div class="card border-0 mb-3">
          <div class="row no-gutters d-flex align-items-center">
            <div class="col-md-3 col-4">
              <img src="../../assets/image/recursos/ico-5.png" class="card-img" alt="...">
            </div>
            <div class="col-md-9 col-8">
              <div class="card-body text-md-start text-center">
                <h5 class="card-title fw-bold subtitle text-lago d-md-block d-none"><u>Ventas, Ingresos y Gastos</u></h5>
                <p class="card-title fw-bold subtitle text-lago d-md-none d-block"><u>Ventas, Ingresos y Gastos</u></p>
                <p class="card-text fw-bold text-md-left text color-1 text lh-sm text-justify">Lleva el control de tu
                  flujo de dinero, registra tus ventas,
                  ingresos y gastos.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-12">
        <div class="card border-0 mb-3">
          <div class="row no-gutters d-flex align-items-center">
            <div class="col-md-3 col-4">
              <img src="../../assets/image/recursos/ico-6.png" class="card-img" alt="...">
            </div>
            <div class="col-md-9 col-8 text-md-start text-center">
              <div class="card-body">
                <h5 class="card-title fw-bold subtitle text-lago d-md-block d-none"><u>Acceso Móvil</u></h5>
                <p class="card-title fw-bold subtitle text-lago d-md-none d-block"><u>Acceso Móvil</u></p>
                <p class="card-text fw-bold text-md-left text color-1 text lh-sm text-justify">Acceda por la pagina web
                  o descargue el App desde cualquier
                  lugar</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 my-5">
    <div class="row d-flex align-items-center">
      <div class="col-lg-7 col-md-6 col-12">
        <div class="container p-md-5 p-1">
          <h3 class="text-lago text-center title fw-bold">SISTEMA MOVIL PARA COMERCIOS</h3>
          <p class="subtitle fw-bold text-rojo">Con el sistema móvil generar boletas, tomar pedidos, administrar el
            inventario entre otras operaciones dentro de su negocio sera mas sencillo y fácil de usar, desde un celular
          </p>
          <ul class="text fw-bold list-center text-rojo">
            <li>Panel de lista de pedidos, donde podrás observar todos los pedidos realizados antes de generar la
              orden en cocina/barra.</li>
            <li>Cada mozo tendrá un usuario para la atención, por lo que podrás controlar la cantidad de mesas
              atendidas por mozo.</li>
            <li>Controla el estado de los pedidos, veras si están pendientes de atención, atendidos o cancelados.</li>
            <li>El panel de mesas te permitirá diferenciar que mesas están ocupadas y que mesas están libres.</li>
            <li>Agrega observaciones a tus pedidos. ¡Algunos clientes no quieren el ceviche con picante!</li>
            <li>El sistema móvil cuenta con una carta virtual interactiva para la toma de pedidos.</li>
            <li>Podrás ver el precio de tus platos y modificar la cantidad.</li>
          </ul>
          <!-- <div class="row mt-3">
            <div class="col-md-6 col-12 px-0">
              <div class="card border-0 bg-pantano">
                <div class="card-body">
                  <h5 class="text-center title text-naranja">INSTALACIÓN</h5>
                  <p class="text-justify text fw-bold text-humo lh-sm">Lorem ipsum dolor sit amet consectetur
                    adipisicing elit. Officia aut repudiandae labore, asperiores sint, praesentium consectetur cum
                    repellendus aperiam assumenda tempora voluptas omnis modi et, inventore corrupti pariatur alias
                    animi.</p>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-12 px-0">
              <div class="card border-0 bg-humo">
                <div class="card-body">
                  <h5 class="text-center title text-naranja">SOPORTE</h5>
                  <p class="text-justify text text-lago lh-sm fw-bold">Lorem ipsum dolor sit amet consectetur
                    adipisicing elit. Officia aut repudiandae labore, asperiores sint, praesentium consectetur cum
                    repellendus aperiam assumenda tempora voluptas omnis modi et, inventore corrupti pariatur alias
                    animi.</p>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <div class="col-lg-5 col-md-6 col-12 px-0">
        <div class="carousel-f"
          data-flickity='{ "bgLazyLoad": 1, "autoPlay": true, "wrapAround": false, "fullscreen": true }'>
          <img src="../../assets/image/movil/comercio-1.jpg" class="carousel-cell" alt="">
          <img src="../../assets/image/movil/comercio-2.jpg" class="carousel-cell" alt="">
          <img src="../../assets/image/movil/comercio-3.jpg" class="carousel-cell" alt="">
          <img src="../../assets/image/movil/comercio-4.jpg" class="carousel-cell" alt="">
          <img src="../../assets/image/movil/pedidos-1.jpg" class="carousel-cell" alt="">
          <img src="../../assets/image/movil/pedidos-3.jpg" class="carousel-cell" alt="">
          <!-- <div class="carousel-cell" data-flickity-bg-lazyload="https://unsplash.it/480/645/?random"></div>
          <div class="carousel-cell" data-flickity-bg-lazyload="https://unsplash.it/480/646/?random"></div> -->
        </div>
      </div>
    </div>
  </div>
</section>
<footer-web class="mt-5 mx-0"></footer-web>
